import { OurSectorsSection } from "@modules/home/components";
import { trans } from "@mongez/localization";

export function AboutUsOurSectorsSection() {
  return (
    <section className="bg-white py-8 sm:py-12 md:py-16 lg:py-20">
      <div className="container">
        {/* Header */}
        <div className="mb-8 px-4 sm:mb-10 md:mb-12 lg:mb-14 lg:px-8 xl:mb-16">
          <h1 className="mb-4 text-2xl font-semibold leading-tight tracking-tight text-secondary sm:text-3xl sm:leading-tight md:text-4xl md:leading-[1.2] lg:text-[42px] lg:leading-[1.2] xl:text-5xl xl:leading-[1.2] xl:tracking-[-0.1rem] 2xl:text-title 2xl:leading-[96px] 2xl:tracking-[-0.15rem]">
            {trans("aboutUsPage.ourSectors.title")}
          </h1>
        </div>

        <div className="overflow-hidden rounded-lg sm:rounded-xl md:rounded-2xl lg:rounded-3xl xl:rounded-[44px]">
          <OurSectorsSection />
        </div>

        {/* Bottom Content */}
        <div className="container mt-6 text-sm text-marine sm:mt-8 sm:text-base md:mt-10 md:text-lg lg:mt-12 lg:text-lg xl:text-xl 2xl:text-2xl">
          <p className="mb-4">{trans("aboutUsPage.ourSectors.description")}</p>

          <p className="mb-4">{trans("aboutUsPage.ourSectors.description2")}</p>

          <p>
            {trans("aboutUsPage.ourSectors.description3", {
              symbol: <span className="font-rubik">^</span>,
            })}
          </p>
        </div>
      </div>
    </section>
  );
}
